module.exports = __webpack_public_path__ + "static/media/image2.2042d4ed.jpg";